export default function PageStepperDefaultIco({ size, color }) {
  return (
    <svg
      width={size || "32"}
      height={size || "32"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill={color || "#EBF1F4"} />
    </svg>
  );
}
